import gameInfo from '../assets/json/gameInfo.json';
import Phaser from 'phaser';
import gameData, { GameShortNames } from './gameData.js';
import FontKeys from './FontKeys';
import ABCyaLib from '@abcya/abcya_lib';
import ABCyaPhaser from '@abcya/abcya_phaser';
import setupGameConfig from './GameConfig';

const fonts = [];
for (const k in FontKeys) {
  fonts.push(FontKeys[k]);
}

// note: uncomment or change the following based on what you need to load
ABCyaPhaser.Preloader.PreloaderConfig.fonts = fonts;

/**
 * To load multiple image sprites, change this property to an array of Phaser.Types.Loader.FileTypes.MultiAtlasFileConfig objects.
 * Ex: ABCyaPhaser.Preloader.PreloaderConfig.imagesPath = [
 * { key: ABCyaPhaser.Images.DEFAULT_ATLAS, atlasURL: 'assets/images/' + ABCyaPhaser.Images.DEFAULT_ATLAS + '.json', path: 'assets/images' }, // default multiatlas
 * { key: "particles", atlasURL: 'assets/images/particles.json', path: 'assets/images' }
 * ]
 */
ABCyaPhaser.Preloader.PreloaderConfig.imagesPath = 'assets/images';

/**
 * To load multiple audio sprites, change this property to an array of Phaser.Types.Loader.FileTypes.AudioSpriteFileConfig objects.
 * Note: you should always include an ogg and mp3 file, the game will determine which to use based on compatibility. 
 * Ex: ABCyaPhaser.Preloader.PreloaderConfig.soundsPath = [
 * { key: ABCyaPhaser.Audio.DEFAULT_AUDIO_SPRITE, 
 *   jsonURL: 'assets/sounds/' + DEFAULT_AUDIO_SPRITE + '.json', 
 *   audioURL: [ 'assets/sounds/' + DEFAULT_AUDIO_SPRITE + '.ogg', 'assets/sounds/' + DEFAULT_AUDIO_SPRITE + '.mp3' ] }, // default sound sprite
 * { key: "extrasounds", jsonURL: 'assets/sounds/extrasounds.json', audioURL: [ 'assets/sounds/extrasounds.ogg', 'assets/sounds/extrasounds.mp3' ] }
 * ]
 */
ABCyaPhaser.Preloader.PreloaderConfig.soundsPath = 'assets/sounds';

/**
 * You can load spine objects here. This can be an object with key, jsonPath, and atlasPath properties, or an array of those objects.
 * Ex: ABCyaPhaser.Preloader.PreloaderConfig.spines = [
 * { key: "spine0", jsonPath: "assets/spines/spine0.json", atlasPath: "assets/spines/spine0.atlas" },
 * { key: "spine1", jsonPath: "assets/spines/spine1.json", atlasPath: "assets/spines/spine1.atlas" }
 * ]
 */
// ABCyaPhaser.Preloader.PreloaderConfig.spines = { key: "", jsonPath: "", atlasPath: "" };

ABCyaPhaser.Preloader.PreloaderConfig.startScene = gameData.startScene;

/**
 * Called when the preload function is done.
 * @param {Phaser.Scene} scene the preloader scene
 */
ABCyaPhaser.Preloader.PreloaderConfig.preloadCallback = (scene) => {
  // insert additional preloader functionality here; scene is the preloader scene
  scene.load.bitmapFont('pixelFont', 'assets/fonts/pixelFont.png', 'assets/fonts/pixelFont.xml');
};

(async function handshake() {
  try {
    await ABCyaLib.Environment.instance.doParentHandshake();
  }
  catch (error) {
    console.warn(error);
  }

  console.info('ABCya Game Info:', gameInfo);

  // check to see which game is being set. default is regular version.
  gameData.game = ABCyaLib.getConfig()?.game ?? gameData.game;
  gameData.STORAGE_PREFIX = gameData.game === GameShortNames.regular ? 'super_santa' : 'super_santa_jr';

  // setup the game config on the Environment object
  ABCyaLib.Environment.instance.setupGameConfig(setupGameConfig);

  /**
     * Use the fourth argument of initializePhaserGame to override default Phaser config options
     * For example: to use the Spine plugin, the fourth argument should look like this:
     * { 
            configOverrides: {
                plugins: {
                    scene: [
                        { key: 'SpinePlugin', plugin: window.SpinePlugin, mapping: 'spine' }
                    ]
                }
            }
        }
     */
  ABCyaPhaser.Misc.initializePhaserGame(1024, 768, gameData.scenes);

  // initialize any functionality in abcya_phaser that has a dependency on abcya_lib 
  ABCyaPhaser.Misc.initializeAbcyaLibDependencies(ABCyaLib);
}());
